import { Box, FormControl, FormLabel, TextField } from '@mui/material';
import type React from 'react';
import { useState } from 'react';
import type { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { borderRadius, palette } from '../../../../assets/styles/themes/tokens';
import { muiInputFieldBorderStyle } from '../../../../constants';
import { useId } from '../../../../utils/useId';

interface CollectionTitleProps {
	inputRef: React.Ref<HTMLInputElement>;
	error?: FieldError;
	initialValue?: string;
}

const CollectionTitle = ({ inputRef, error, initialValue }: CollectionTitleProps) => {
	const { t } = useTranslation();
	const [title, setTitle] = useState(initialValue);
	const fieldId = useId('title');
	const labelId = `${fieldId}-label`;
	const errorId = `${fieldId}-error`;
	const helperTextId = error ? errorId : undefined;

	return (
		<Box>
			<FormLabel id={labelId} htmlFor={fieldId} sx={{ color: palette.text.primary }}>
				{t('Title *')}
			</FormLabel>
			<FormControl fullWidth>
				<TextField
					id={fieldId}
					fullWidth
					size="medium"
					variant="outlined"
					data-testid="collection-title-input"
					placeholder={t('eg Meinungen begründen 5 Klasse or Geo Nordsee')}
					inputProps={{
						'aria-labelledby': labelId,
						'aria-describedby': helperTextId,
						'aria-invalid': !!error || undefined,
						'aria-required': true,
					}}
					sx={{
						borderRadius: borderRadius.sm,
						...muiInputFieldBorderStyle,
					}}
					value={title}
					onChange={(e) => setTitle(e.target.value)}
					name="title"
					inputRef={inputRef}
					error={!!error}
					helperText={error?.message}
					required
					FormHelperTextProps={{
						id: helperTextId,
						role: error ? 'alert' : undefined,
					}}
				/>
			</FormControl>
		</Box>
	);
};

export default CollectionTitle;
